import { makeStyles } from "tss-react/mui";
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const useStyles = makeStyles()((_0, _1, _2)=>{
    let _ref = [
        _0,
        _1,
        _2
    ], [_ref1, ..._rest] = _ref, {} = _ref1, theme = _extends({}, _ref1), [_, ..._rest1] = _rest, [classes] = _rest1;
    return {
        root: {
            width: theme.px(280),
            paddingLeft: theme.tokens.spacing['16'],
            paddingBottom: theme.tokens.spacing['8'],
            paddingRight: theme.tokens.spacing['16'],
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.tokens.typography.variant.body3.fontSize,
            '& .react-calendar__month-view__weekdays': {
                display: 'flex',
                alignItems: 'center',
                gap: theme.tokens.spacing['4'],
                '& .react-calendar__month-view__weekdays__weekday': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    maxWidth: theme.px(32),
                    height: theme.px(32),
                    fontSize: theme.tokens.typography.variant.caption.fontSize,
                    color: theme.tokens.colors.text.light.tertirary,
                    textTransform: 'uppercase',
                    '&:nth-child(6):disabled, &:last-child:disabled': {
                        color: theme.tokens.colors.text.light.tertirary
                    },
                    '& > *': {
                        textDecoration: 'none'
                    }
                }
            },
            '& .react-calendar__month-view__days': {
                gap: theme.tokens.spacing['4']
            }
        },
        monthName: {
            padding: theme.tokens.spacing['16'],
            paddingBottom: theme.tokens.spacing['12'],
            display: 'flex',
            justifyContent: 'space-between'
        },
        day: {
            position: 'relative',
            maxWidth: theme.px(32),
            height: theme.px(32),
            backgroundColor: 'transparent',
            border: 'none',
            borderRadius: theme.tokens.radius.s,
            overflow: 'visible !important',
            fontSize: theme.tokens.typography.variant.body3.fontSize,
            color: theme.tokens.colors.text.light.primary,
            padding: 0,
            marginLeft: 0,
            [`&:disabled:not(.${classes.selectedRangeDay})`]: {
                color: theme.tokens.colors.text.light.tertirary
            },
            [`&:disabled.${classes.selectedRangeDay}`]: {
                color: theme.tokens.colors.text.light.primary
            },
            [`&:not(.${classes.selectedRangeDay}):not(:disabled):hover:not(.${classes.readOnly}):not(.${classes.blockedRangeDay})`]: {
                backgroundColor: theme.tokens.colors.original.brand.secondary,
                boxShadow: `inset 0 0 0 ${theme.tokens.border.s}px ${theme.tokens.colors.original.brand.primary}`,
                cursor: 'pointer'
            },
            '&.react-calendar__month-view__days__day--weekend:not(.react-calendar__month-view__days__day--neighboringMonth)': {
                [`&:not(.${classes.selectedRangeDay}):disabled`]: {
                    color: theme.tokens.colors.text.light.tertirary
                }
            },
            '&.react-calendar__month-view__days__day--neighboringMonth': {
                color: theme.tokens.colors.text.light.tertirary
            }
        },
        readOnly: {
            cursor: 'default'
        },
        selectedRangeDay: {
            cursor: 'default',
            '&:before': {
                position: 'absolute',
                top: 0,
                left: -theme.tokens.spacing['2'],
                zIndex: -1,
                height: theme.px(32),
                width: theme.px(36),
                backgroundColor: theme.tokens.colors.original.brand.quaternary,
                content: "''"
            },
            [`&.${classes.rangeStart}.${classes.rangeEnd}`]: {
                '&:before': {
                    width: theme.px(32),
                    left: 0,
                    right: 0,
                    borderTopLeftRadius: theme.tokens.radius.s,
                    borderBottomLeftRadius: theme.tokens.radius.s,
                    borderTopRightRadius: theme.tokens.radius.s,
                    borderBottomRightRadius: theme.tokens.radius.s
                }
            },
            [`&.${classes.selectedRangeDayStart}.${classes.selectedRangeDayEnd}`]: {
                '&:before': {
                    width: theme.px(32)
                }
            },
            '&.react-calendar__month-view__days__day--neighboringMonth': {
                '&:before': {
                    opacity: 0.3
                }
            }
        },
        rangeStart: {
            color: theme.tokens.colors.text.dark.primary,
            backgroundColor: theme.tokens.colors.original.brand.primary,
            '&.react-calendar__month-view__days__day--neighboringMonth': {
                color: theme.tokens.colors.text.dark.primary
            },
            [`&:not(.${classes.rangeEnd})`]: {
                '&:before': {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    backgroundColor: theme.tokens.colors.original.brand.quaternary,
                    borderTopLeftRadius: theme.tokens.radius.s,
                    borderBottomLeftRadius: theme.tokens.radius.s,
                    content: "''"
                }
            }
        },
        rangeEnd: {
            color: theme.tokens.colors.text.dark.primary,
            backgroundColor: theme.tokens.colors.original.brand.primary,
            '&.react-calendar__month-view__days__day--neighboringMonth': {
                color: theme.tokens.colors.text.dark.primary
            },
            [`&:not(.${classes.rangeStart})`]: {
                '&:before': {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    backgroundColor: theme.tokens.colors.original.brand.quaternary,
                    borderTopRightRadius: theme.tokens.radius.s,
                    borderBottomRightRadius: theme.tokens.radius.s,
                    content: "''"
                }
            }
        },
        selectedRangeDayStart: {
            [`&:not(.${classes.rangeStart})`]: {
                '&:before': {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    backgroundColor: theme.tokens.colors.original.brand.quaternary,
                    borderTopLeftRadius: theme.tokens.radius.s,
                    borderBottomLeftRadius: theme.tokens.radius.s,
                    content: "''"
                }
            }
        },
        selectedRangeDayEnd: {
            [`&:not(.${classes.rangeEnd})`]: {
                '&:before': {
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    borderTopRightRadius: theme.tokens.radius.s,
                    borderBottomRightRadius: theme.tokens.radius.s,
                    backgroundColor: theme.tokens.colors.original.brand.quaternary,
                    content: "''"
                }
            }
        },
        holiday: {
            color: theme.tokens.colors.accent.text.error,
            '&:disabled': {
                color: theme.tokens.colors.text.light.tertirary
            }
        },
        regionalHoliday: {
            '&::after': {
                content: "''",
                position: 'absolute',
                bottom: theme.px(2),
                left: '50%',
                transform: 'translateX(-50%)',
                width: theme.px(4),
                height: theme.px(4),
                borderRadius: '50%',
                backgroundColor: theme.palette.error.hover
            }
        },
        deletedRangeDay: {
            cursor: 'default',
            [`&:not(.${classes.selectedRangeDay})`]: {
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    left: -theme.tokens.spacing['2'],
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(36),
                    borderTop: `${theme.tokens.border.m}px solid ${theme.tokens.colors.stroke.primary}`,
                    borderBottom: `${theme.tokens.border.m}px solid ${theme.tokens.colors.stroke.primary}`
                }
            },
            [`&.${classes.selectedRangeDay}`]: {
                '&::before': {
                    backgroundColor: '#c8d7fa'
                }
            },
            '&.react-calendar__month-view__days__day--neighboringMonth': {
                '&::before': {
                    opacity: 0.3
                }
            }
        },
        deletedRangeDayStart: {
            [`&:not(.${classes.selectedRangeDay})`]: {
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    borderLeft: `${theme.tokens.border.m}px solid ${theme.tokens.colors.stroke.primary}`,
                    borderTopLeftRadius: theme.tokens.radius.s,
                    borderBottomLeftRadius: theme.tokens.radius.s
                }
            }
        },
        deletedRangeDayEnd: {
            [`&:not(.${classes.selectedRangeDay})`]: {
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    borderTopRightRadius: theme.tokens.radius.s,
                    borderBottomRightRadius: theme.tokens.radius.s,
                    borderRight: `${theme.tokens.border.m}px solid ${theme.tokens.colors.stroke.primary}`
                }
            }
        },
        blockedRangeDay: {
            cursor: 'default',
            [`&:not(.${classes.selectedRangeDay})`]: {
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    left: -theme.tokens.spacing['2'],
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(36),
                    background: theme.tokens.colors.bg.greyscale.tertirary
                }
            },
            '&.react-calendar__month-view__days__day--neighboringMonth': {
                '&::before': {
                    opacity: 0.3
                }
            }
        },
        blockedRangeDayStart: {
            [`&:not(.${classes.selectedRangeDay})`]: {
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    backgroundColor: theme.tokens.colors.bg.greyscale.tertirary,
                    borderTopLeftRadius: theme.tokens.radius.s,
                    borderBottomLeftRadius: theme.tokens.radius.s
                }
            }
        },
        blockedRangeDayEnd: {
            [`&:not(.${classes.selectedRangeDay})`]: {
                '&::before': {
                    content: "''",
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: -1,
                    height: theme.px(32),
                    width: theme.px(34),
                    borderTopRightRadius: theme.tokens.radius.s,
                    borderBottomRightRadius: theme.tokens.radius.s,
                    backgroundColor: theme.tokens.colors.bg.greyscale.tertirary
                }
            }
        },
        compensationRangeDay: {
            '&::before': {
                content: "''",
                position: 'absolute',
                top: 0,
                left: -theme.tokens.spacing['2'],
                zIndex: -1,
                height: theme.px(32),
                width: theme.px(36),
                borderTop: `1.5px dashed ${theme.tokens.colors.original.brand.primary}`,
                borderBottom: `1.5px dashed ${theme.tokens.colors.original.brand.primary}`
            },
            '&.react-calendar__month-view__days__day--neighboringMonth': {
                '&::before': {
                    opacity: 0.3
                }
            }
        },
        compensationRangeDayStart: {
            '&::before': {
                left: 0,
                width: theme.px(34),
                borderLeft: `1.5px dashed ${theme.tokens.colors.original.brand.primary}`,
                borderTopLeftRadius: theme.tokens.radius.s,
                borderBottomLeftRadius: theme.tokens.radius.s
            }
        },
        compensationRangeDayEnd: {
            '&::before': {
                left: 'auto',
                right: 0,
                width: theme.px(34),
                borderRight: `1.5px dashed ${theme.tokens.colors.original.brand.primary}`,
                borderTopRightRadius: theme.tokens.radius.s,
                borderBottomRightRadius: theme.tokens.radius.s
            }
        }
    };
});
const Month_styles = useStyles;
export default Month_styles;
